module.exports = __webpack_public_path__ + "img/F908.21613bf1.jpg";